<template>
  <div class="common">
    <search-form
      :noAdvance="true"
      :formConfig="formConfig"
      :source="searchData"
      @search="search"
    >
    </search-form>
    <a-spin :spinning="loading" style="max-width:1440px">
      <a-row :gutter="[16, 16]">
        <a-col
          :xs="24"
          :sm="12"
          :md="12"
          :lg="8"
          :xl="6"
          v-for="item in tableData"
          :key="item.name"
        >
          <div class="bank-card">
            <div class="head spaceLeft ">
              <span
                v-if="dict.bankListMap[item.bankCd]"
                :class="dict.bankListMap[item.bankCd]"
                class="logo"
              ></span>
              <div
                class="ellipsis"
                style="flex:1 0 0;"
                :title="item.tenantName"
              >
                {{ item.tenantName }}
              </div>
            </div>
            <div class="body">
              <template v-if="item.approvalStatus == 2 || item.approvalStatus == 4">
                <div class="spaceCenter">
                  <div
                    :class="colorMap[item.approvalStatus]"
                    class="status"
                  >
                  <a-popover title="拒绝原因">
                    <template slot="content">
                      <div style="color:#666;max-width:200px;">
                        {{ item.opinion || "暂无原因" }}
                      </div>
                    </template>
                    <span>{{item.approvalStatus | dictFilter(aprovalStatus)}}</span>
                  </a-popover>
                  </div>
                </div>
              </template>

              <template v-else>
                <div class="spaceCenter">
                  <div
                    :class="colorMap[item.approvalStatus]"
                    class="status"
                  >
                    <span>{{item.approvalStatus | dictFilter(aprovalStatus)}}</span>
                  </div>
                </div>
              </template>

              <div class="spaceCenter text">
                <span
                  v-if="
                    item.approvalStatus == 0 ||
                      item.approvalStatus == 2 ||
                      item.approvalStatus == 4
                  "
                  >点击申请建档，提交信息</span
                >
                <span v-else
                  ><a-icon
                    type="clock-circle"
                    style="margin-right:5px"
                  />{{moment(item.updateTime).format("YYYY-MM-DD HH:mm")}}</span
                >
              </div>
              <div class="spaceCenter">
                <a-button
                  v-if="
                    item.approvalStatus == 0 ||
                      item.approvalStatus == 2 ||
                      item.approvalStatus == 4
                  "
                  type="primary"
                  @click="toAdd(item)"
                  >申请建档</a-button
                >
                <a-button v-else class="btn-blue-line" @click="toInfo(item)"
                  >查看</a-button
                >
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
      <div>
        <a-pagination class="bank-page" size="small" v-model="pagination.current" :pageSize.sync="pagination.pageSize" :total="pagination.total" :show-total="total => `共 ${pagination.total} 条`" show-quick-jumper  @change="getTableData"/>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { bankBuildingList } from "@/api/bank.js";
export default {
  components: {},
  data() {
    return {
      loading: false,
      searchData: {
        tenantName: undefined,
        approvalStatus: undefined
      },
      formConfig: [
        {
          prop: "tenantName",
          type: "input",
          label: "银行名称"
        },
        {
          prop: "approvalStatus",
          type: "select",
          label: "审核状态",
          option: [],
          defaultProps: {
            label: "dctValNm",
            value: "dctVal"
          }
        }
      ],
      columns: [
        {
          title: "银行名称",
          dataIndex: "name"
        },
        {
          title: "状态	",
          dataIndex: "status",
          align: "left",
          scopedSlots: { customRender: "status" }
        },
        {
          title: "操作	",
          dataIndex: "oper",
          scopedSlots: { customRender: "oper" }
        }
      ],
      tableData: [],
      pagination: {
        pageSize: 12,
        current: 1,
        sortField: "",
        sortOrder: "",
        total: 0
      },
      loading: false,
      colorMap: {
        0: "weitijiao",
        1: "shenhezhong",
        2: "shenheshibai",
        3: "shenhezhong",
        4: "shenheshibai",
        5: "shenhetongguo"
      },
      aprovalStatus: []
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      getDicAsync: "app/getDicAsync"
    }),
    search(data) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      const params = {
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        ...this.searchData
      };
      bankBuildingList(params)
        .then(res => {
          this.loading = false;
          this.pagination.total = res.data.grid.total || 0;
          this.tableData = res.data.grid.list;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        });
    },
    toAdd(data) {
      this.MENUAPI.goToOneTab({
        path: "bank/bankAdd",
        query: {
          bankCd: data.bankCd,
          status: data.status,
          tenantOrgCode: data.tenantOrgCode,
          tenantId: data.tenantId,
          accountNo:data.accountNo
        }
      });
    },
    toInfo(data) {
      this.MENUAPI.goToOneTab({
        path: "bank/bankInfo",
        query: {
          ...data
        }
      });
    }
  },
  created() {
    this.getDicAsync("BankBuildingAprovalStatus").then(res => {
      this.aprovalStatus = res;
      this.formConfig.forEach((i, idx) => {
        if (i.prop == "approvalStatus") {
          this.formConfig[idx].option = this.aprovalStatus;
        }
      });
    });
    this.getTableData();
  },
  mounted() {},
  watch: {}
};
</script>
<style scoped lang="less">
.spont {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 100%;
  background: #fff;
  margin-right: 8px;
  position: relative;
  top: -3px;
}
.status {
  display: inline-block;
  padding:0 16px 0 0;
  height: 26px;
  line-height: 26px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin: 12px 0 8px 0;
}
.weitijiao {
  &::before {
    content: "";
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("../../assets/images/bank/weitijiao.svg") no-repeat;
    background-size: contain;
    position: relative;
    left: -5px;
    top: -1px;
    float: left;
  }
  background: #e5e9ec;
  color: #737f8e;
  border-radius: 20px 4px 4px 20px;
}
.shenhetongguo {
  &::before {
    content: "";
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("../../assets/images/bank/tongguo.svg") no-repeat;
    position: relative;
    left: -5px;
    top: -1px;
    background-size: contain;
    float: left;
  }
  background: #E4FCF6;
  color: #3AC09F;
  border-radius: 20px 4px 4px 20px;
}
.shenheshibai {
  &::before {
    content: "";
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("../../assets/images/bank/shibai.svg") no-repeat;
    position: relative;
    left: -5px;
    top: -1px;
    background-size: contain;
    float: left;
  }
  background: #fff1f0;
  color: #ee5059;
  border-radius: 20px 4px 4px 20px;
}
.shenhezhong {
  &::before {
    content: "";
    display: inline-block;
    width: 28px;
    height: 28px;
    background: url("../../assets/images/bank/shenhezhong.svg") no-repeat;
    position: relative;
    left: -5px;
    top: -1px;
    background-size: contain;
    float: left;
  }
  background: #e2f1ff;
  color: #52abff;
  border-radius: 20px 4px 4px 20px;
}
.bank-card {
  background: #fff;
  box-shadow: 0 0 6px 3px rgba(134, 147, 154, 0.1);
  border-radius: 3px;
  .head {
    line-height: 48px;
    height: 48px;
    border-bottom: 1px solid #eef5fb;
    font-size: 18px;
    color: #333333;
    font-weight: bold;
    padding: 0 12px;
  }
  .body {
    .text {
      color: #737f8e;
      margin-bottom: 8px;
    }
    button {
      width: 150px;
      margin-bottom: 16px;
    }
  }

}
  .bank-page{
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bank/bank-list.vue